<template>
  <Form 
    :d_form='form1'
    :d_negara='negara'
    :d_negeri='negeri'
    :d_peran='peran'
    :d_cawangan='cawangan'
    :d_jenis_pengguna='jenis_pengguna'
    :d_poskod='poskod'
    :d_bandar='bandar'
    :d_peran_admin='peran_admin'
    v-if="id > 0 && load == 9"
  /> 
  <Form 
    :d_form='form'
    :d_negara='negara'
    :d_negeri='negeri'
    :d_peran='peran'
    :d_cawangan='cawangan'
    :d_jenis_pengguna='jenis_pengguna'
    :d_poskod='poskod'
    :d_bandar='bandar'
    :d_peran_admin='peran_admin'
    v-else-if="id == 0 && load == 4"
  /> 
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'administration.user',
      crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Utama', route: '/' },
        { label: 'Pentadbiran', route: '/administration/user' },
        { label: 'Pengguna', route: '/administration/user' },
      ],
      title : 'Tambah Baka Jantan',
      form : {
        id : 0,
        warga_negara : '',
        role_id: '',
        lkp_jenis_pengguna_id: '',
        no_id: '',
        email:'',
        name:'',
        alamat:'',
        dir:'',
        no_tel: '',
        no_tel_pejabat: '',
        lkp_negeri_id: '',
        lkp_bandar_id: '',
        lkp_poskod_id: '',
        lkp_negara_id: '',
        lkp_cawangan_id: '',
        permission_id : [],
        password:'',
        status:'',
        no_siri:'',
        tarikh_lantikan: '',
        peranan:0
      },
      form1:[],
      peran:[],
      bandar: [],
      poskod:[],
      cawangan: [],
      se_katalog : [],
      peran_admin: [],
      negeri: [],
      negara: [],
      jenis_pengguna: [],
      load : 0
      
      
    }
  },
  methods: {

    getNegeri(){
      this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
         this.negeri = res
         this.load = this.load + 1
      })
    },

    getNegara(){
         this.$zcomm.get(this.api_service + 'lookup/negara', {}).then(res => {
           // this.negara = res
            this.negara = res.filter(item => item.value !== 1);
           this.load = this.load + 1
         })
      },
 
    getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'administration/pengguna/'+this.id, {}).then(res => {
          this.form1 = res
          if(this.form1.lkp_jenis_pengguna_id){this.getCapaian();}else{this.load = this.load + 1}
          if(this.form1.lkp_negeri_id){this.getCawangan();}else{this.load = this.load + 1}
          if(this.form1.lkp_poskod_id){this.getBandar();}else{this.load = this.load + 1}
          if(this.form1.lkp_bandar_id){this.getPoskod();}else{this.load = this.load + 1}
          this.load = this.load + 1

        })
      }
    },
    getCapaian(id){
        if(this.form.role_id != null || this.form.role_id != ''){
           this.form.role_id = null;
        }
        this.$zcomm.get(this.api_service + 'lookup/capaian/'+this.form1.lkp_jenis_pengguna_id, {}).then(res => {
          this.peran = res
          this.load = this.load + 1
        })
    },
    getCapaianAdmin(id){
        this.$zcomm.get(this.api_service + 'lookup/capaian/0', {}).then(res => {
          this.peran_admin = res
          this.load = this.load + 1
        })
    },

    getCawangan(id){
        if(this.form.lkp_negeri_id!=null||this.form.lkp_negeri_id!=''){
           this.form.lkp_bandar_id == 0;
           this.form.lkp_poskod_id == 0;
           this.form.lkp_cawangan_id == 0;
           this.form.alamat == '';
        }
        this.$zcomm.get(this.api_service + 'lookup/cawangan/'+this.form1.lkp_negeri_id, {}).then(res => {
          this.cawangan = res
          this.load = this.load + 1
        })
    },
    getPoskod(id){
        this.$zcomm.get(this.api_service + 'lookup/poskod/'+this.form1.lkp_bandar_id, {}).then(res => {
          this.poskod = res
          this.load = this.load + 1
        })
    },
    getBandar(id){
        this.form.lkp_bandar_id == '';
        this.$zcomm.get(this.api_service + 'lookup/bandar_poskod/'+this.form1.lkp_poskod_id, {}).then(res => {
           this.bandar = res
           this.load = this.load + 1
        })
    },

    getlkpJenisPengguna(){
        this.$zcomm.get(this.api_service + 'lookup/jenis_pengguna', {}).then(res => {
          this.jenis_pengguna = res
          this.load = this.load + 1
        })
    },
  
  },

  watch: {

  },
  mounted() {
    this.getData();
    this.getNegeri()
    this.getNegara()
    this.getlkpJenisPengguna()
    this.getCapaianAdmin()
    
  }
    
}
</script>
